import React from 'react';

type InputType = 'text' | 'password' | 'email' | 'number' | 'tel' | 'url' | 'search';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
	type?: InputType;
	label?: string;
	error?: string;
	containerClassName?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ type = 'text', label, error, className = '', containerClassName = '', ...props }, ref) => {
	return (
		<div className={`mb-4 ${containerClassName}`}>
			{label && <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>}
			<input
				ref={ref}
				type={type}
				className={`w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors ${error ? 'border-red-500' : 'border-gray-300'} ${
					props.disabled ? 'bg-gray-100 cursor-not-allowed' : ''
				} ${className}`}
				{...props}
			/>
			{error && <p className="mt-1 text-sm text-red-600">{error}</p>}
		</div>
	);
});

Input.displayName = 'Input';

export default Input;
